// How the app's agent chats reach the server: the endpoints, the auth token and
// the render plugins. The chat page (AgentChatPageV2) and the page helper beside
// a page (usePageAgentHost) share them, so a helper's chat is an ordinary chat.
import axios from 'axios'
import { carbonTablePlugin } from '../plugins/carbonTablePlugin'
import { carbonChartPlugin } from '../plugins/carbonChartPlugin'
import { dashboardPlugin } from '../plugins/dashboardPlugin'
import { compositeTablePlugin } from '../plugins/compositeTablePlugin'
import { provenanceValidationPlugin } from '../plugins/provenanceValidationPlugin'
import { warehouseQueryPlugin } from '../plugins/warehouseQueryPlugin'
import { analysisNoticePlugin } from '../plugins/analysisNoticePlugin'
import { skillDraftPlugin } from '../plugins/skillDraftPlugin'

export const getAuthToken = () => {
  const h = axios.defaults.headers.common['Authorization'] as string | undefined
  return h?.replace(/^Bearer\s+/, '') ?? ''
}

export function platinumV2Endpoints(customer: string) {
  const base = `/api/v1/agentkit/agent/${customer}`
  return {
    createSession:  `${base}/session`,
    sendMessage:    (id: string) => `${base}/session/${id}/message`,
    reconnect:      (id: string) => `${base}/session/${id}/reconnect`,
    status:         (id: string) => `${base}/session/${id}/status`,
    cancel:         (id: string) => `${base}/session/${id}/cancel`,
    pageToolResult: (id: string) => `${base}/session/${id}/page-tool-result`,
    getSession:     (id: string) => `${base}/session/${id}`,
    deleteSession:  (id: string) => `${base}/session/${id}`,
    messages:       (id: string) => `${base}/session/${id}/messages`,
    queryEvents:    (id: string) => `${base}/session/${id}/query-events`,
    artifacts:      (id: string) => `${base}/session/${id}/artifacts`,
    upload:         (id: string) => `${base}/session/${id}/upload`,
    listSessions:   `${base}/sessions`,
    searchMessages: `${base}/messages/search`,
    workflowRun:        (id: string, run: string) => `${base}/session/${id}/workflows/${run}`,
    workflowTranscript: (id: string, run: string, agent: string) => `${base}/session/${id}/workflows/${run}/agents/${agent}`,
  }
}

/** The render plugins the chat page registers. Exported so the design showcase draws with the same set. */
export const AGENT_PLUGINS = [carbonTablePlugin, carbonChartPlugin, dashboardPlugin, compositeTablePlugin, provenanceValidationPlugin, analysisNoticePlugin, warehouseQueryPlugin, skillDraftPlugin]
